import React, { ReactNode, useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';

import Button, { ButtonStyle } from '@components/Button';
import { WizardContext } from '@components/Wizard/Wizard';

interface IProps {
  children: ReactNode | ReactNode[] | ((isLastStep: boolean) => ReactNode | ReactNode[]);
  isDisabledOverride?: (args: {
    stepIndex: number;
    stepsCount: number;
    isLastStep: boolean;
    isInitialized: boolean;
    formik: ReturnType<typeof useFormikContext>;
  }) => boolean | undefined;
}

function WizardNextButton({ children, isDisabledOverride }: IProps) {
  const formik = useFormikContext();
  const { isValid, submitForm, validateForm } = formik as any;
  const { isInitialized, stepIndex, setStepIndex, stepsCount } = useContext(WizardContext);

  useEffect(() => {
    validateForm();
  }, [stepIndex, isInitialized]);

  const onClick = async () => {
    if (isLastStep) {
      await submitForm();
    } else {
      setStepIndex(stepIndex + 1);
    }
  };

  const isLastStep = stepIndex >= stepsCount - 1;
  const overriddenDisabled =
    typeof isDisabledOverride === 'function'
      ? isDisabledOverride({ stepIndex, stepsCount, isLastStep, isInitialized, formik })
      : undefined;
  const disabled = overriddenDisabled !== undefined ? overriddenDisabled : !isValid || !isInitialized;
  return (
    <Button style={ButtonStyle.Primary} disabled={disabled} onClick={onClick}>
      {typeof children === 'function' ? children(isLastStep) : children}
    </Button>
  );
}

export default WizardNextButton;
